import $ from 'jquery';
import { setSessionStorageCurrentProduct } from 'src/utils/utils';

import initProductNavigation from './productNavigation/pdpProductNavigation';
import initVariants from './variants';
import initRecentlyViewed from './recentlyViewed/recentlyViewed';

$(() => {
  initVariants();
  initRecentlyViewed();
  initProductNavigation();
  setSessionStorageCurrentProduct();
});
